// Scrollable main fields block for TaskForm (title, tags, schedule, description, subtasks).
import { Box } from '@mui/material';
import TaskDescriptionEditor from '@/features/tasks/components/forms/fields/TaskDescriptionEditor';
import TaskDateTimeFields from '@/features/tasks/components/forms/fields/TaskDateTimeFields';
import { fieldLabelSx } from '@/features/tasks/components/forms/taskFormStyles';
import { TASK_FORM_HEADER_GAP } from '@/features/tasks/components/forms/taskFormConstants';
import { useT } from '@/i18n/useT';
import { TaskFormSubtasksBlock } from '@/features/tasks/components/forms/TaskFormSubtasksBlock';
import { TaskFormTitleField } from '@/features/tasks/components/forms/TaskFormTitleField';
import { TaskFormTagRow } from '@/features/tasks/components/forms/TaskFormTagRow';

/**
 * @param {object} props
 */
export function TaskFormScrollBody({
  pinFormActions,
  titleInHeader,
  task,
  errors,
  handleChange,
  handleDescriptionChange,
  tagRowProps,
  dateTimeFieldProps,
  isNewTask,
  initialTaskId,
  subtaskRows,
  onToggleSubtaskComplete,
  onAddPendingSubtask,
  onSaveSubtask,
}) {
  const t = useT();

  return (
    <Box
      data-testid={pinFormActions ? 'task-form-scroll-body' : undefined}
      sx={
        pinFormActions
          ? {
              flex: 1,
              minHeight: 0,
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: TASK_FORM_HEADER_GAP,
              pb: 1,
            }
          : { display: 'contents' }
      }
    >
      {!titleInHeader ? (
        <TaskFormTitleField
          task={task}
          errors={errors}
          handleChange={handleChange}
        />
      ) : null}

      <TaskFormTagRow {...tagRowProps} />

      <TaskDateTimeFields {...dateTimeFieldProps} />

      <Box className="form-panel-container">
        <Box component="label" sx={fieldLabelSx}>
          {t('taskform.description', 'Description')}
        </Box>
        <Box sx={{ mt: 0.5 }}>
          <TaskDescriptionEditor
            content={task.description}
            onChange={handleDescriptionChange}
          />
        </Box>
      </Box>

      <TaskFormSubtasksBlock
        isNewTask={isNewTask}
        parentId={initialTaskId}
        subtaskRows={subtaskRows}
        onToggleComplete={onToggleSubtaskComplete}
        onAddPendingSubtask={onAddPendingSubtask}
        onSaveSubtask={onSaveSubtask}
      />
    </Box>
  );
}
